
const state = {
  fullScreenEnabled: false,
  showRemoveBtn: false,
  floatVideos: [],
  alarmsTS: 0,
  isAltPressed: false,
  canAddSlot: true,
};

const mutations = {
  setAlarmsTS(state, value) {
    state.alarmsTS = value;
  },
  setFullScreen(state, value) {
    state.fullScreenEnabled = value;
  },
  setShowRemoveBtn(state, value) {
    state.showRemoveBtn = value
  },
  setAltPressed(state, value) {
    state.isAltPressed = value;
  },
  setCanAddSlot(state, value) {
    state.canAddSlot = value;
  },
  addFloatVideos(state, value) {
    state.floatVideos.push(value)
  },
  removeFloatVideos(state, value) {
    state.floatVideos = state.floatVideos.filter(video => {
      return video.id != value.id || video.type != value.type
    })
  },
};

const actions = {
  updateAlarms({ commit }) {
    commit('setAlarmsTS', new Date().getTime());
  },
  setFullScreen({ commit }, data) {
    commit('setFullScreen', data);
  },
  setAltPressed({ commit }, data) {
    commit('setAltPressed', data);
  },
  setCanAddSlot({ commit }, data) {
    commit('setCanAddSlot', data);
  },
  addFloatVideos({ commit }, data) {
    commit('addFloatVideos', data);
  },
  removeFloatVideos({ commit }, data) {
    commit('removeFloatVideos', data);
  },
};

const getters = {
  getFloatVideos(state) {
    return state.floatVideos;
  },
  getFullScreen(state) {
    return state.fullScreenEnabled;
  },
  getAltPressed(state) {
    return state.isAltPressed;
  },
  getCanAddSlot(state) {
    return state.canAddSlot;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
};
